var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDriverIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.149 7.10939L5.91725 8.03108C5.81075 8.4528 5.52425 8.80822 5.13275 9.00269L3.98375 9.57343C3.20075 9.96237 2.62775 10.6717 2.41475 11.5159L2 13.1663H4.33333M9.851 7.10939L10.0828 8.03108C10.1885 8.4528 10.4758 8.80822 10.8673 9.00269L12.0155 9.57343C12.7993 9.96237 13.3723 10.6717 13.5845 11.5159L14 13.1663H11.6667M8.9 8.02549C8.36675 8.42263 7.63325 8.42263 7.1 8.02549C5.77775 7.04047 5 5.49439 5 3.85294V3.48039C5 1.83447 6.34325 0.5 8 0.5C9.65675 0.5 11 1.83447 11 3.48039V3.85294C11 5.49439 10.2215 7.04047 8.9 8.02549Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99992 15.1667C9.10449 15.1667 9.99992 14.2712 9.99992 13.1667C9.99992 12.0621 9.10449 11.1667 7.99992 11.1667C6.89535 11.1667 5.99992 12.0621 5.99992 13.1667C5.99992 14.2712 6.89535 15.1667 7.99992 15.1667ZM7.99992 15.8333C9.47268 15.8333 10.6666 14.6394 10.6666 13.1667C10.6666 11.6939 9.47268 10.5 7.99992 10.5C6.52716 10.5 5.33325 11.6939 5.33325 13.1667C5.33325 14.6394 6.52716 15.8333 7.99992 15.8333Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.99992 13.1667C8.99992 13.719 8.5522 14.1667 7.99992 14.1667C7.44763 14.1667 6.99992 13.719 6.99992 13.1667C6.99992 12.6144 7.44763 12.1667 7.99992 12.1667C8.5522 12.1667 8.99992 12.6144 8.99992 13.1667Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.66659 13.4181L5.57501 12.8205L5.75816 12.1795L7.99992 12.82L10.2417 12.1795L10.4248 12.8205L8.33325 13.4181V15.5H7.66659V13.4181Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDriverIcon);
export default __webpack_public_path__ + "static/media/driverIcon.d87b58c2d2b09db229510a4a8689b614.svg";
export { ForwardRef as ReactComponent };